var EntityDocumentType;
(function (EntityDocumentType) {
    EntityDocumentType["voidedCheck"] = "voided_check";
    EntityDocumentType["balanceSheet"] = "balance_sheet";
    EntityDocumentType["bankStatement"] = "bank_statement";
    EntityDocumentType["governmentId"] = "government_id";
    EntityDocumentType["profitAndLossStatement"] = "profit_and_loss_statement";
    EntityDocumentType["taxReturn"] = "tax_return";
    EntityDocumentType["other"] = "other";
})(EntityDocumentType || (EntityDocumentType = {}));
var EntityDocumentStatus;
(function (EntityDocumentStatus) {
    EntityDocumentStatus["pending"] = "pending";
    EntityDocumentStatus["uploaded"] = "uploaded";
    EntityDocumentStatus["canceled"] = "canceled";
    EntityDocumentStatus["needed"] = "needed";
})(EntityDocumentStatus || (EntityDocumentStatus = {}));
class EntityDocumentStorage {
    constructor() {
        this.voided_check = [];
        this.balance_sheet = [];
        this.bank_statement = [];
        this.government_id = [];
        this.profit_and_loss_statement = [];
        this.tax_return = [];
        this.other = [];
    }
}
class EntityDocument {
    constructor(fileData, business_id) {
        this.file = fileData.file;
        this.fileString = this.getFileString();
        this.document_type = fileData.document_type;
        this.presigned_url = null;
        this.record_data = {
            business_id: business_id,
            document_type: this.document_type,
            file_name: this.file.name,
            file_type: this.file.type,
        };
    }
    getFileString() {
        let reader = new FileReader();
        reader.onload = (e) => {
            this.fileString = e.target.result;
        };
        reader.readAsDataURL(this.file);
        return this.fileString;
    }
    setPresignedUrl(url) {
        this.presigned_url = url;
    }
}

export { EntityDocumentType as E, EntityDocument as a, EntityDocumentStorage as b };
